module.exports = __webpack_public_path__ + "static/media/ic_template_9.a74b0f15.png";